// Campo "Reactivado por masivo": texto libre con sugerencias de los masivos que
// ya escribieron otras asesoras, para que todas usen el mismo nombre. Si no
// existe, se crea al guardar (el API lo deduplica sin importar tildes o mayúsculas).
import React from 'react'
import { Box, Input, Text } from '@chakra-ui/react'

import xhr from 'xhr'

const normalize = (text) =>
  String(text || '')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/\s+/g, ' ')
    .trim()

export default function MasivoInput({ value, onChange }) {
  const [options, setOptions] = React.useState([])
  const [open, setOpen] = React.useState(false)

  React.useEffect(() => {
    if (!open) return undefined
    const timer = setTimeout(async () => {
      try {
        const res = await xhr.get('/masivos/search', { params: { q: value || '' } })
        setOptions(Array.isArray(res.data) ? res.data : [])
      } catch (error) {
        console.error(error)
        setOptions([])
      }
    }, 200)
    return () => clearTimeout(timer)
  }, [value, open])

  const exact = options.some((el) => normalize(el.name) === normalize(value))
  const showCreate = Boolean(value?.trim()) && !exact

  return (
    <Box position="relative">
      <Input
        id="origin-masivo"
        size="sm"
        maxLength={120}
        autoComplete="off"
        placeholder="Ej.: Promo bachillerato octubre"
        value={value}
        onFocus={() => setOpen(true)}
        onBlur={() => setTimeout(() => setOpen(false), 150)}
        onChange={(e) => {
          onChange(e.target.value)
          setOpen(true)
        }}
      />
      {open && (options.length > 0 || showCreate) && (
        <Box
          position="absolute"
          zIndex={20}
          top="100%"
          left={0}
          right={0}
          mt={1}
          bg="white"
          border="1px solid"
          borderColor="gray.200"
          borderRadius="md"
          boxShadow="md"
          maxH="220px"
          overflowY="auto"
          role="listbox"
        >
          {options.map((el) => (
            <Box
              key={el.id}
              role="option"
              px={3}
              py={2}
              fontSize="sm"
              cursor="pointer"
              _hover={{ bg: 'purple.50' }}
              onMouseDown={(e) => {
                e.preventDefault()
                onChange(el.name)
                setOpen(false)
              }}
            >
              {el.name}
            </Box>
          ))}
          {showCreate && (
            <Text px={3} py={2} fontSize="xs" color="gray.500" borderTop={options.length ? '1px solid' : 0} borderColor="gray.100">
              Al guardar se crea el masivo «{value.trim()}».
            </Text>
          )}
        </Box>
      )}
    </Box>
  )
}
